import { CLEAR_ALL_DATA, RESET_APP_ERROR, SAVE_APP_DATA, } from '../../helper/constants';

const initialState = {
  firstName: '',
  surName: '',
  role: '',
  email: '',
  mobileNumber: '',
  phoneOption: undefined,
  haveWhatsApp: '',
  surroPlansClient: '',

  firstNameSecond: '',
  surNameSecond: '',
  roleSecond: '',
  daysCountFirstYear: '',
  daysCountSecondYear: '',
  daysCountThirdYear: '',
  daysCountCurrentYear: '',
  daysCountNextYear: '',
  daysCountFirstYearSecond: '',
  daysCountSecondYearSecond: '',
  daysCountThirdYearSecond: '',
  daysCountCurrentYearSecond: '',
  daysCountNextYearSecond:  '',
  emailSecond: '',
  mobileNumberSecond: '',
  phoneOptionSecond: undefined,
  haveWhatsAppSecond: '',
  surroPlansClientSecond: '',

  processConsent: undefined,

  surrogateCurrentMatch: '',
  usAgencyInvolved: '',
  usLawyerInvolved: '',
  internationalAgencyInvolved: '',
  internationalLawyerInvolved: '',
  approximateTransferDate: '',
  approximateDateCheck: '',

  haveMedicalCoverage: '',

  haveDeadlines: '',
  deadline: '',
  haveDeadlineAdditionalInfo: '',
  deadlineAdditionalInfo: '',

  privacyStatement: undefined,
  errorScreenCounter: 0,

  childNumberYouHave: '',
  surrogateChildNumber: '',
  surrogateChildNumber_noSSN: '',
  surrogateChildNumber_noPassport: '',
  surrogateChildNumber_noTravelPapers: '',
  additionalSurrogateChildNumber: '',
}

export default (state = initialState, {type, payload}) => {
  switch(type) {
    case SAVE_APP_DATA: {
      return {
        ...state,
        ...payload,
      }
    }
    case CLEAR_ALL_DATA: {
      return {
        ...initialState,
        ...payload
      }
    }
    case RESET_APP_ERROR: {
      return {
        ...state,
        error: '',
        errorScreenMessage: '',
        errorScreenCounter: 0
      }
    }
    default:
      return state;
  }
}

export const getInitialValue = (fieldName, fallbackValue) => {
  return initialState.hasOwnProperty(fieldName) ? initialState[fieldName] : fallbackValue;
}

export const getInitialField = (field) => {
  const fieldName = Object.keys(field)[0];
  return {
    [fieldName]: getInitialValue(fieldName)
  }
}